var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryFolder = function SvgCategoryFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.008 6.943h-6.474a1 1 0 0 1-.83-.44l-1.4-2.064a1 1 0 0 0-.83-.437H5.003a2 2 0 0 0-2 2v12.006a2 2 0 0 0 2 2h14.006a2 2 0 0 0 2-2V8.944a2 2 0 0 0-2-2.001",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.001 9.884h6.474a1 1 0 0 0 .826-.437l1.4-2.066a1 1 0 0 1 .828-.438"
  })));
};
export { SvgCategoryFolder as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDIwYzk2YWJjZmZiZDY3YjBlYTI2NTRiN2NiYTU0ZWEuc3ZnIjs=";